module.exports = __webpack_public_path__ + "static/WelcomeToElk2-6910432b0231f3534764b5ffb445d8c8.png";